<script setup>

import KdContainer from "./kdContainer.vue";

</script>

<template>
  <kd-container>
    <el-form :model="form" :rules="rules" ref="formRef" label-width="158px">
      <div v-for="(sItem, index) in form.suggestionItems" :key="index">
        <div class="suggestionTitle">
          <div>{{sItem.staffName}}</div>
        </div>
        <div>
          <div v-if="problemType == '0'">
            <el-form-item label="是否存在质量问题" :prop="`suggestionItems.${index}.hasReasonAnalystMaterial`" :rules="rules.hasReasonAnalystMaterial">
              <el-radio-group :disabled="disableStatus" v-model="sItem.hasReasonAnalystMaterial">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <div v-else>
            <el-form-item label="是否存在包装问题" :prop="`suggestionItems.${index}.hasReasonAnalystMaterial`" :rules="rules.hasReasonAnalystMaterial">
              <el-radio-group :disabled="disableStatus" v-model="sItem.hasReasonAnalystMaterial">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <el-form-item label="根因分析" :prop="`suggestionItems.${index}.reasonAnalyst`" :rules="rules.reasonAnalyst">
            <el-input :disabled="disableStatus" v-model="sItem.reasonAnalyst" type="textarea" placeholder="请输入根因分析" :autosize="{ minRows: 4, maxRows: 4 }" maxlength="500" show-word-limit></el-input>
          </el-form-item>
          <el-form-item>
            <file-upload-list
              v-if="disableStatus"
              ref="fileUploadList"
              :fileList="sItem.file"
            ></file-upload-list>
            <drag-upload
              v-else
              ref="uploadFile"
              :accessoryList.sync="sItem.file"
              :httpRequest="imAction"/>
          </el-form-item>
        </div>
      </div>
      <el-divider v-if="showCompletionProcess"></el-divider>
      <el-form-item v-if="showCompletionProcess" label="是否申请结束流程" prop="requestCompletionProcess">
        <el-radio-group :disabled="disableStatus" v-model="form.requestCompletionProcess">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-button class="lang-but" type="primary" @click="auditPassBtClick">通过</el-button>
        <el-button class="lang-but" type="danger" @click="auditRejectBtClick">驳回</el-button>
      </el-form-item>
    </el-form>

    <kd-audit-pass-dialog
      :visible.sync="auditPassDialogVisible"
      v-model="form.auditText"
      @confirm="onAuditPassConfirm"
    />

    <div>
      <el-dialog width="600px !important" title="审核驳回" :visible.sync="dialogVisible">
        <el-form :model="form" :rules="rules" ref="rejectFormRef" label-width="85px">
          <el-form-item label="驳回原因" prop="rejectReason">
            <el-input v-model="form.rejectReason" type="textarea" placeholder="请输入驳回原因" :autosize="{ minRows: 4, maxRows: 4 }" maxlength="500" show-word-limit></el-input>
          </el-form-item>
          <div class="submitArea">
            <el-button type="primary" @click="auditRejectSubmit()">提交</el-button>
            <el-button plain  @click="dialogVisible = false">取消</el-button>
          </div>
        </el-form>
      </el-dialog>
    </div>
  </kd-container>
</template>

<style scoped lang="scss">

</style>
<script>
import {baseURL} from "../../util/url";
import {requestSubmitAudit} from "../../api/feedback";
import {requestSubmitAuditKD} from "@/api/feedbackKD";
import KdAuditPassDialog from "./kdAuditPassDialog.vue";

/**
 * 13.2-质量改善部部长审核根因分析
 */
export default {
  name: "kdQualityReasonAnalystAudit",
  components: { KdAuditPassDialog },
  props: {
    taskId:String,
    questionId:String,
    taskDefKey:String,
    problemType:String,
    qualityEnd:Boolean,
    suggestionItems: {
      type: Array,
      default: () => []
    },
    disableForm:{
      type: Boolean,
      default: false
    },
    receivedForm:{
      hasQualityProblem:Number,
      reasonAnalystMaterial: String,
      reasonAnalyst: String,
      requestCompletionProcess:Number,
      file:{
        type: Array,
        default: undefined
      }
    }
  },
  data() {
    return {
      header: {
        satoken: sessionStorage.getItem("token")
      },
      disableStatus: false,
      imAction: "/manage/staff/upload?fileType=auditResource",
      dialogVisible:false,
      auditPassDialogVisible: false,
      form:{
        requestCompletionProcess: 1,
        rejectReason:"",
        auditText: "",
        suggestionItems:[
          {
            userId:"",
            hasReasonAnalystMaterial: 1,
            reasonAnalyst: "",
            reasonAnalystMaterial: "",
            file: []
          }
        ]
      },
      rules: {
        hasReasonAnalystMaterial: [
          {
            required: true, message: "是否存在质量问题不能为空", trigger: ["blur", "change"]
          }
        ],
        reasonAnalyst: [
          {
            required: true, message: "根因分析不能为空", trigger: ["blur", "change"]
          }
        ],
        requestCompletionProcess: [
          {
            required: true, message: "是否申请结束流程不能为空", trigger: ["blur", "change"]
          }
        ],
        rejectReason: [
          {
            required: true, message: "驳回原因不能为空", trigger: ["blur", "change"]
          }
        ]
      }
    }
  },
  watch: {
    hasTempSolution: function (val) {
      this.$emit("hasTempSolution", val);
    }
  },
  computed: {
    showCompletionProcess() {
      return !this.form.suggestionItems.some(item => item.hasReasonAnalystMaterial == 1)
    }
  },
  methods: {
    auditPassBtClick() {
      this.$refs['formRef'].validate((valid, object) => {
        if (this.getRequiredValid(valid, object)){
          return
        }
        this.auditPassDialogVisible = true;
      })

    },
    onAuditPassConfirm(auditText) {
      let formData = {
        nowTaskId: this.taskId,
        questionId: this.questionId,
        taskDefKey: this.taskDefKey,
        auditText: auditText,
        variables: {
          approval: true,
        },
      }
      requestSubmitAuditKD(formData).then(res => {
        if (res.status == "0") {
          this.$DonMessage.success('审批通过!');
          this.backRouterPath();
        }else {
          this.$DonMessage.error(res.message);
        }
      })
    },
    auditRejectBtClick() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.rejectFormRef?.resetFields();
      })
    },
    auditRejectSubmit(){
      this.$refs['rejectFormRef'].validate((valid, object) => {
        if (this.getRequiredValid(valid, object)){
          return
        }
        let formData = {
          nowTaskId: this.taskId,
          questionId: this.questionId,
          taskDefKey: this.taskDefKey,
          auditText: this.form.rejectReason,
          variables: {
            approval: false
          },
        }
        requestSubmitAuditKD(formData).then(res => {
          if (res.status == "0") {
            this.$DonMessage.success('驳回成功!');
            this.backRouterPath();
            this.dialogVisible = false;
          } else {
            this.$DonMessage.error(res.message);
          }
        })
      })

    }
  },
  mounted() {
    this.form.suggestionItems = this.suggestionItems;
    this.form.requestCompletionProcess = this.qualityEnd===true?1:0;
    if (this.taskDefKey == 'Activity_070sjiw' ||
        this.taskDefKey == 'Activity_0vnhfut' ||
        this.taskDefKey == 'Activity_00hrf3u' ||
        this.taskDefKey == 'Activity_0odad8y' ||
        this.taskDefKey == 'Activity_0frj90o' ||
        this.taskDefKey == 'Activity_1w5edej' ||
        this.taskDefKey == 'Activity_0wvr9ix' ) {
      this.disableStatus = true
    } else {
      this.disableStatus = false
    }
  }
}
</script>
